import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import Text from 'shopper/components/Text';

const TYPES = {
  DOTS: 'dots',
  GHOST: 'ghost',
};

const listItemTypes = ({ type }) => {
  const types = {
    [TYPES.DOTS]: css`
      list-style: inside;
    `,
    [TYPES.GHOST]: css`
      list-style: none;
    `,
  };

  return types[type];
};

const StyledText = styled(Text)`
  ${listItemTypes}
`;

const ListItem = ({ type, children, ...rest }) => (
  <StyledText as="li" type={type} {...rest}>
    {children}
  </StyledText>
);

ListItem.defaultProps = {
  type: TYPES.DOTS,
};

ListItem.propTypes = {
  /**
   * Controls the list-style of component, being used only when this component
   * isn't wrapped by a `ListGroup`
   */
  type: PropTypes.oneOf(Object.values(TYPES)),
  children: PropTypes.node.isRequired,
};

export default ListItem;
